import React from "react"

export const MusicFilterEditor: React.FC = () => {
  return (
    <span className="text-sm text-coval-text-muted">
      Regions detected as music or hold tones.
    </span>
  )
}
